import store from '@/store';
import { nextTick } from 'vue';
import { useRoute } from 'vue-router'; // @ts-ignore
// import VConsole from 'vconsole/dist/vconsole.min'
// const vConsole = new VConsole()

export default {
  name: 'CollectBase',

  setup() {
    const route = useRoute();
    nextTick(() => {
      const param = {
        method: 'getUserInfo',
        params: {},
        callback: 'onReceiveUser'
      };

      if (route.query && route.query.token) {
        store.dispatch('SaveToken', route.query.token);
      }

      if (window.HybridAPI !== undefined) {
        window.HybridAPI.onReceiveUser = msg => {
          const data = JSON.parse(msg);
          store.dispatch('SaveToken', data.token);
        };

        window.HybridAPI.sendToNative(JSON.stringify(param));
      }
    });
    return {// vConsole
    };
  }

};